// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

function NoMarkerInData() {
  return (
    <div id="noMarkerInData">
      <p>
        No data for this marker.
      </p>
      <p>
        Please check the marker long name in the URL, and replace it if necessary.
      </p>
      <p>You can also return to the </p>
      <a href="/" className="noMarkerInDataLink">HomePage</a>
      <p>and get a new query.</p>
    </div>
  );
}

export default NoMarkerInData;
